import {Alert, useOpenModal} from '@/components/Modal'
import {useMapContext} from '@/components/MindMap/index.mjs'
import openWindow from '@/script/openWindow.mjs'

export default props => {
    const openModal = useOpenModal()
    const map = useMapContext()
    const {mapTypeCode, prjId, sVer} = map.data

    if ('_UI_MAP' !== mapTypeCode) {
        return null
    }

    const onClick = async () => {
        const {
            layoutPicId,
            layoutTypeCode,
            layoutTypeId,
            pkid: uiId,
            rev,
            uiName,
        } = map.root.data

        if (! layoutTypeCode) {
            await openModal(
                <Alert type="error">
                    界面属性面板未选择界面布局类型
                </Alert>
            )

            return
        }

        const bizMap = {
            layoutPicId,
            layoutTypeCode,
            layoutTypeId,
            prjId,
            rev,
            sVer,
            uiId,
        }

        openWindow(
            '/Ai',

            {
                bizMap,
                prjId,
                scene: 'GENERATE_UV',
                sVer,
                title: `用户界面: ${uiName}`,
            }
        )
    }

    return {
        label: '界面视图',
        onClick,
        ...props,
    }
}
